<template>
  <pagelayout>
    <div class="topay-page">
      <div class="header">
        <div class="wrapper">
          <div class="btn-back" @click="routeBack">
            <i class="iconfont jiantou-left"></i>
          </div>
          <div class="logo">
            <img src="~@img/pages/topay/logo.png" alt="">
          </div>
          <div class="button" @click="expand = !expand">
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
          </div>
        </div>
        <v-expand-transition>
          <v-card v-show="expand" dark flat color="transparent">
            <v-card-title :key="index" v-for="(item, index) in navRoute"
            @click="switchRoute(item.key)" class="font-weight-bold">{{item.title}}</v-card-title>
          </v-card>
        </v-expand-transition>
      </div>
      <div class="course-header">
        <div class="container">
          <div class="desc">TOPAY钱包教程</div>
          <div class="line"></div>
        </div>
      </div>
      <main class="main-box">
        <div class="ok-btn-group" :class="{'ok-btn-group-open': expandSelect}">
          <div @click="expandSelect = !expandSelect" class="btn">
            <div class="tab-click">
              <img :src="`${_cdn}/pay_icon/okpay/${courseArr.findIndex(item => item.key == activeKey)}.png`" alt="">
              <span>{{ courseArr.find(item => item.key == activeKey).title }}</span>
            </div>
            <span class="caret"></span>
          </div>
          <ul class="dropdown-menu">
            <li @click="() => {activeKey = item.key; expandSelect = false}" class="tab-click tab"
            v-for="(item, index) in courseArr" :key="index">
              <img :src="`${_cdn}/pay_icon/okpay/${index}.png`" alt="">
              <span>{{item.title}}</span>
            </li>
          </ul>
        </div>
        <div class="list" :class="[{'dis':activeKey == item.key}, `${item.key}`]" v-for="(item, index) in courseArr" :key="index">
          <div class="h3">{{item.title}}</div>
          <div class="block">
            <div class="flow-detail">
              <img :src="`${_cdn}/pay_icon/topay/${item.key}.png`" alt="">
            </div>
          </div>
        </div>
      </main>
    </div>
  </pagelayout>
</template>

<script>
export default {
  name: 'topayCourse',
  data() {
    return {
      expand: false,
      expandSelect: false,
      navRoute: [
        { key: 'topay', title: '首页' },
        { key: 'topayCourse', title: '教程' }
      ],
      activeKey: 'buy',
      courseArr: [
        { key: 'buy', title: '买币教程' },
        { key: 'sale', title: '卖币教程' },
        { key: 'charge', title: '充值教程' },
        { key: 'withdraw', title: '提现教程' }
      ],
      Link: [
        {
          id: 9,
          iosLink: 'https://rueh54l.top:12407/7bb725bc',
          andLink: 'https://topay1.oss-cn-beijing.aliyuncs.com/topay.apk'
        },
        {
          id: 10,
          iosLink: 'https://ipa510.cc/s/yDuX',
          andLink: 'https://topay1.oss-cn-beijing.aliyuncs.com/topay.apk'
        }
      ]
    }
  },
  computed: {
    route() {
      return this.$route.name
    },
    _cdn() {
      return this.$store.getters["app/cdn"];
    },
  },
  methods: {
    switchRoute(key) {
      if(this.route == key) {
        this.expand = false
      } else {
        this.$router.push(`/${key}`)
      }
    },
    download(key, item) {
      if(key == 'ios') {
        window.open(item.iosLink)
      } else if(key == 'and') {
        window.open(item.andLink)
      }
    },
    routeBack({ numb = -1 }) {
      const currHref = window.location.href;
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
      } else {
        this.$router.go(numb);
        setTimeout(() => {
          if (window.location.href == currHref) {
            if (window.android) {
              window.android.goBack();
            }
            this.$router.push({ path: "/" });
          }
        }, 100);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.topay-page {
  background: #fff;
  .header {
    background: rgb(59, 57, 64);
    .v-card {
      border-top: 1px solid transparent;
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, .1) !important;
      .v-card__title {
        padding: 10px 15px;
        line-height: 20px !important;
        &:first-of-type {
          margin-top: 7.5px;
        }
      }
    }
    .wrapper {
      height: 58px;
      padding: 0 16px;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      box-sizing: border-box;
      display: flex;
      background: #3b3940;
      .btn-back {
        color: #fff;
      }
      .logo {
        width: 90px;
        height: 32px;
        img {
          width: 90px;
          height: 32px;
        }
      }
      .button {
        width: 26px;
        height: 20px;
        background: #fff;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        flex-direction: column;
        padding: 3px;
        .line {
          background-color: #000;
          width: 16px;
          height: 2px;
        }
      }
    }
  }
  .course-header {
    background: url('~@img/pages/topay/tutorial_head.png') no-repeat 50%;
    background-size: 100% 100%;
    height: 80px;
    .container {
      padding: 0;
      padding-top: 24px;
      .desc {
        color: #e6bd7f;
        text-align: center;
        margin-bottom: 16px;
      }
      .line {
        width: 80px;
        height: 1px;
        background: #ffffff;
        margin: 0 auto;
      }
    }
  }
  .main-box {
    padding: 2%;
    background: linear-gradient(to right, #201e26, #1f1e25);
    .tab-click {
      width: 100%;
      min-height: unset;
      background: none;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      text-shadow: 0 1px 0 #fff;
      img {
        width: 8%;
        height: auto;
        margin: 0 5px;
        display: block;
      }
    }
    .ok-btn-group {
      width: 100%;
      margin: 0 auto;
      display: block;
      padding: 50px 0;
      padding-top: 0;
      position: relative;
      .btn {
        user-select: none;
        margin-bottom: 0;
        font-weight: 400;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        touch-action: manipulation;
        cursor: pointer;
        color: #333;
        padding: 10px 16px;
        font-size: 18px;
        line-height: 1.3333333;
        border-radius: 6px;
        position: relative;
        float: left;
        width: 100%;
        background: #ffffff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-shadow: 0 1px 0 #fff;
        border-color: #ccc;
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(0, 0, 0,.08);
        &:hover {
          background-position: 0 -15px;
        }
        .caret {
          border-width: 6px 6px 0;
          border-bottom-width: 0;
          display: inline-block;
          width: 0;
          height: 0;
          vertical-align: middle;
          border-top: 6px dashed;
          border-right: 6px solid transparent;
          border-left: 6px solid transparent;
        }
      }
    }
    .ok-btn-group-open {
      .btn {
        &:focus,
        &:active,
        &:hover {
          color: #333;
          background-color: #d4d4d4;
          border-color: #8c8c8c;
        }
      }
      .dropdown-menu {
        display: block;
      }
    }
    .dropdown-menu {
      width: 100%;
      position: absolute;
      top: 100%;
      left: 0;
      z-index: 1000;
      display: none;
      float: left;
      min-width: 160px;
      padding: 5px 0;
      margin: 2px 0 0;
      font-size: 14px;
      text-align: left;
      list-style: none;
      background-color: #fff;
      background-clip: padding-box;
      border: 1px solid rgba(0,0,0,.15);
      border-radius: 4px;
      box-shadow: 0 6px 12px rgba(0, 0, 0, .18);
      line-height: 1.42857143;
      .tab {
        width: 100%;
        min-height: unset;
        background: none;
        display: flex;
        justify-content: flex-start;
        padding: 5px;
        height: max-content;
        border-radius: 10px;
        align-items: center;
      }
    }
    .list {
      padding: 20px 0;
      background: #ffffff;
      margin-top: 5%;
      display: none;
    }
    .dis {
      display: block;
      .h3 {
        color: #000;
        text-align: center;
        font-size: 24px;
        margin-top: 20px;
        margin-bottom: 10px;
        font-weight: 500;
        line-height: 1.1;
      }
      .block {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        flex-wrap: wrap;
        .flow-detail {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin: 30px auto;
          width: 100%;
          img {
            width: 100%;
            height: auto;
            display: block;
          }
        }
      }
    }
  }
}
</style>